// extracted by mini-css-extract-plugin
export default {"strike-divider":"divider_strike-divider__I69Bj","no-text":"divider_no-text__oNAqi"};